import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Hide Small Towns studio covers the studio fails to serve, instead of showing a broken-image icon.
document.addEventListener("error", (e) => {
  const el = e.target;
  if (el?.tagName === "IMG" && el.src.includes("/api/public/")) el.style.visibility = "hidden";
}, true);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
